import { useState, useEffect } from "react";
import "./EventCard.scss";

const Events = ({ announcement }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [eventImages, setEventImages] = useState([]);

  const fetchEventImages = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/event-images/event/${announcement.id}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response:", data);

      // Map the data to include the full image URL
      const processedData = data.map((item) => ({
        ...item,
        imageUrl: `${process.env.REACT_APP_API_URL_IMAGE}${item.image}`,
      }));

      console.log("Processed Data:", processedData);

      setEventImages(processedData);
    } catch (error) {
      console.error("Error fetching event images:", error);
      setEventImages([]);
    }
  };

  const handleLearnMore = () => {
    fetchEventImages();
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEventImages([]);
  };

  const truncateText = (text, limit) => {
    if (text.length > limit) {
      return text.substring(0, limit) + "...";
    }
    return text;
  };

  const imageUrl = `${process.env.REACT_APP_API_URL_IMAGE}${announcement.image}`;

  return (
    <div className="announcement-container">
      <div className="announcement-card">
        <div className="announcement-card1">
          <img
            src={imageUrl}
            alt={announcement.heading}
            className="announcement-image"
          />
        </div>

        <div className="announcement-card2">
          <p className="announcement-date">{announcement.date}</p>
          <h3 className="announcement-title">{announcement.heading}</h3>
          <p className="announcement-description">
            {truncateText(announcement.description, 200)}
          </p>
          <button className="learn-more-btn" onClick={handleLearnMore}>
            <span className="circle" aria-hidden="true">
              <span className="icon arrow"></span>
            </span>
            <span className="button-text">Learn More</span>
          </button>
        </div>
      </div>

      {/* Modal Popup */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content1">
              <img
                src={imageUrl}
                alt={announcement.heading}
                className="modal-image"
              />
            </div>
            <div className="modal-content2">
              <h2 className="modal-title">{announcement.heading}</h2>
              <p className="modal-event">Event Description</p>
              <p className="modal-description">{announcement.description}</p>

              {/* Image Section */}
              <div className="modal-image-section">
                <p className="image-gallery-title">Event Images</p>
                <div className="modal-image-gallery">
                  {eventImages.length > 0 ? (
                    eventImages.map((image, index) => (
                      <div key={index} className="image-container">
                        <img
                          src={image.imageUrl}
                          alt={`Event ${index + 1}`}
                          className="modal-image"
                        />
                      </div>
                    ))
                  ) : (
                    <p>Loading ...</p>
                  )}
                </div>
              </div>

              <button className="close-btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Events;
